import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you are looking for could not be found." path="/404" />
      <div className="min-h-[70vh] flex items-center justify-center bg-navy text-white pt-24 relative overflow-hidden">
        <div className="absolute inset-0 geo-overlay opacity-40" />
        <div className="relative text-center px-6">
          <div className="text-7xl md:text-9xl font-extrabold text-gold">404</div>
          <h1 className="mt-4 text-2xl md:text-3xl font-bold">Page Not Found</h1>
          <p className="mt-3 text-slate-300 max-w-md mx-auto">The page you are looking for does not exist or has moved. Contact us to know more.</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" className="btn-gold rounded-full px-7 py-3 font-bold">Back to Home</Link>
            <Link to="/contact" className="rounded-full px-7 py-3 font-semibold border-2 border-white/30 hover:bg-white/10 transition-colors">Contact Us</Link>
          </div>
        </div>
      </div>
    </>
  );
}
